<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <v-slide-x-reverse-transition>
          <v-alert type="success" class="alert" v-if="alert_success === true">ย้ายสินค้าสำเร็จ !</v-alert>
        </v-slide-x-reverse-transition>
        <ReturnTitle :title="item_name" :price="total" :type="unit_main"/>
        <div class="pa-2">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="detailHeaders" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
            <template v-slot:item="dataDetail" class="grid_btn">
              <tr>
                <td>{{ dataDetail.item.lot_no }}</td>
                <td>{{ item_name = dataDetail.item.product_name }}</td>
                <td>{{ dataDetail.item.date_expired }}</td>
                <td>{{ format_number(dataDetail.item.quantity) }}</td>
                <td>{{ item_unit = unit_main }}</td>
                <td>
                  <div v-if="dataDetail.item.cause_note !== null">{{ dataDetail.item.cause_note }}</div>
                  <div v-else>-</div>
                </td>
                <td>{{ dataDetail.item.supplier_name }}</td>
                <td>
                  <v-btn @click="get_move(dataDetail.item.quantity, dataDetail.item.warehouse_id, dataDetail.item.product_id, dataDetail.item.lot_no)" class="pa-6 ma-2 grad-success-bg white--text">
                    <v-icon>mdi-arrow-up-left</v-icon>ย้ายคลัง
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <v-dialog v-model="move_stock" persistent max-width="650">
          <v-card>
            <v-form ref="add_form" @submit.prevent="save_data">
              <v-card-title>
                การย้ายคลัง (คงเหลือ {{ list_detail.quantity_get }} {{ item_unit }})
              </v-card-title>

              <v-card-text>
                <div class="mb-6">
                  <div class="d-flex">
                    <v-icon>mdi-document</v-icon>
                    <div class="ml-1">คลังที่ต้องการย้าย</div>
                  </div>
                  <div class="grid_full">
                    <div class="mt-3 mr-1">
                      <v-select color="#86bc3a" :items="items" item-text="name" item-value="id" label="กรุณาเลือกคลังที่ต้องการย้าย" :rules="[v => !!v || 'กรุณาเลือกคลังที่ต้องการย้าย']" v-model="list_detail.stock_select" hide-details="auto" required outlined></v-select>
                    </div>
                  </div>
                </div>
                <div class="mb-6">
                  <div class="d-flex">
                    <v-icon>mdi-document</v-icon>
                    <div class="ml-1">จำนวนสินค้า</div>
                  </div>
                  <div class="grid_full">
                    <div class="mt-3 mr-1">
                      <v-text-field color="#86bc3a" type="number" @keypress="onlyNumber($event)" label="กรุณากรอกจำนวนสินค้า" :rules="[v => !!v || 'กรุณากรอกจำนวนสินค้า']" hide-details="auto" required v-model="list_detail.qty" outlined></v-text-field>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="d-flex">
                    <v-icon>mdi-document</v-icon>
                    <div class="ml-1">สาเหตุการย้ายคลัง</div>
                  </div>
                  <div class="grid_full">
                    <div class="mt-3 mr-1">
                      <v-textarea color="#86bc3a" outlined label="กรุณากรอกสาเหตุการย้ายคลัง" :rules="[v => !!v || 'กรุณากรอกสาเหตุการย้ายคลัง']" hide-details="auto" required v-model="list_detail.note"></v-textarea>
                    </div>
                  </div>
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  บันทึก
                </v-btn>
                <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px" @click="move_stock = false">
                  ยกเลิก
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReturnTitle from "./header_return/ReturnTitle";
import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {formatNumber, onlyForNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Return_details",
  components: {ReturnTitle},
  data() {
    return {
      loading_page: false,
      search: null,
      item_name: null,
      item_unit: null,
      unit_main: null,
      move_stock: false,
      alert_success: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      detailHeaders: [
        {
          text: 'ล็อตสินค้า',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '170px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '150px',
        },
        {
          text: 'หมายเหตุ',
          value: 'cause_note',
          sortable: false,
          fixed: true,
          width: '180px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '120px',
        },
      ],
      items: [
        {id: 3, name: 'คลังหลัก'},
        {id: 4, name: 'คลังใกล้หมดอายุ'},
        {id: 5, name: 'คลังทิ้ง'},
      ],
      list_detail: {
        warehouse_id: null,
        product_id: null,
        lot_no: null,
        stock_select: null,
        qty: 1,
        note: null,
        quantity_get: null,
      },
      data_list: [],
    }
  },
  methods: {
    onlyNumber: function(evt) {
      return onlyForNumber(evt)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      return day+'/'+month+'/'+year
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/returns/getlistbyid', {
        product_id: this.$route.params.id,
        type: this.$route.params.type,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.data_list = res.data.object.products
          this.unit_main = res.data.object.unit_main
        }
      })
    },
    get_move(quantity, warehouse_id, product_id, lot_no) {
      this.move_stock = true
      this.list_detail.quantity_get = quantity
      this.list_detail.warehouse_id = warehouse_id
      this.list_detail.product_id = product_id
      this.list_detail.lot_no = lot_no
    },
    save_data() {
      if (this.$refs.add_form.validate()) {
        if (this.list_detail.qty > 0) {
          HTTP.post('/inventory/returns/movestoragefromreturn', {
            user_create: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
            from_warehouse: 'คลังรอคืน',
            warehouse_id: this.list_detail.warehouse_id,
            product_id: this.list_detail.product_id,
            lot_no: this.list_detail.lot_no,
            stock_move_id: this.list_detail.stock_select,
            qty: this.list_detail.qty,
            cause_note: this.list_detail.note,
          }).then((res) => {
            if (res.data.success === true) {
              this.move_stock = false
              this.alert_success = true
              setTimeout(() => this.alert_success = false, 3000)
              setTimeout(() => this.get_data(), 1000)
              this.list_detail.stock_select = null
              this.list_detail.qty = null
              this.list_detail.note = null
            }
            else if (res.data.success === false) {
              Swal.fire({
                text: res.data.message,
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.list_detail.qty = null
              })
            }
          })
        }
        else {
          Swal.fire({
            text: 'จำนวนสินค้าที่ต้องการย้ายต้องมาก 0 !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.list_detail.qty = null
          })
        }
      }
    }
  },
  computed: {
    total() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum,number) => {
        return sum+(number.quantity);
      }, 0)
      return result
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_unit {
  display: grid;
  grid-template-columns: 55% 45%;
}
</style>
